import gql from 'graphql-tag'
import client from '@stores/apollo'

export interface ToggleRemoteInput {
  ids: string[]
  isRemote?: boolean
  noDeskNeeded?: boolean
}

export default function toggleRemote(input: ToggleRemoteInput): Promise<any> {
  return client.gql.mutate({ mutation, variables: { input } })
}

const mutation = gql`
  mutation changeExcludedToEmployees($input: ChangeExcludedToEmployeesInput!) {
    changeExcludedToEmployees(input: $input) {
      employees {
        id
      }
    }
  }
`
